<template>
  <div
    class="relative z-10 w-full flex flex-wrap items-center justify-center py-8 md:mt-0 md:absolute md:inset-0"
  >
    <div
      class="w-full max-w-screen-xl mx-auto px-4 sm:px-6 md:px-8 lg:px-10 xl:px-16 md:mt-14 lg:mt-28"
    >
      <div
        class="mt-8 flex-1 flex flex-col items-center md:max-w-80 lg:max-w-screen-xl"
        :class="imageLeft ? 'md:items-start' : 'md:items-end'"
        data-aos="fade-right"
      >
        <div
          class="font-semibold text-3xl text-center w-full max-w-lg"
          :class="imageLeft ? 'md:text-left' : 'md:text-right'"
        >
          <slot name="title">
            <h1 v-html="title"></h1>
          </slot>
        </div>
        <div
          class="text-lg text-center mt-7 max-w-lg"
          :class="imageLeft ? 'md:text-left' : 'md:text-right'"
        >
          <slot name="subtitle">
            <h2 v-html="subtitle"></h2>
          </slot>
        </div>
      </div>
      <div
        class="mt-8 flex flex-col md:flex-row items-center gap-4"
        :class="imageLeft ? 'md:justify-start' : 'md:justify-end'"
      >
        <slot name="leftButton">
          <a
            v-if="urlLeftButton"
            :href="urlLeftButton"
            :target="leftButtonTargetBlank ? '_blank' : '_self'"
            class="btn-primary min-w-40"
            aria-label="Left button"
          >
            {{ leftButton }}
          </a>
        </slot>
        <slot name="rightButton">
          <a
            v-if="urlRightButton"
            :href="urlRightButton"
            :target="rightButtonTargetBlank ? '_blank' : '_self'"
            class="btn-white"
            aria-label="Right button"
          >
            {{ rightButton }}
          </a>
        </slot>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: {
    title: String,
    subtitle: String,
    backgroundImage: String,
    sectionIdToScroll: String,
    urlRightButton: String,
    urlLeftButton: String,
    leftButton: String,
    rightButton: String,
    leftButtonClass: String,
    leftButtonTargetBlank: {
      type: Boolean,
      default: true,
    },
    rightButtonTargetBlank: {
      type: Boolean,
      default: true,
    },
    imageLeft: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
